import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ReportAction } from '../../store/actions';
import { csvDownload } from '../csv-download';
import Pagination from '../pagination';

class Sale extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    getSalesReport: PropTypes.func,
    location: PropTypes.object,
    sales: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      sold_at_end: '',
      sold_at_start: '',
    };
  }

  componentDidMount() {
    this.props.getSalesReport?.(
      Object?.fromEntries?.(new URLSearchParams(this.props.location?.search)),
    );
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onDownload() {
    csvDownload?.(
      [
        ...(this.props.authHasOffice ? [] : ['Office']),
        'Sold At',
        'Model',
        'Total',
      ],
      this.props.sales?.data,
      r => [
        ...(this.props.authHasOffice ? [] : [r.office?.name]),
        r.sold_at,
        r.vehicle?.model,
        r.total,
      ],
      'SALE-REPORT',
    );
  }

  onSearch() {
    const { sold_at_end, sold_at_start } = this.state;
    if (!(sold_at_end && sold_at_start)) {
      return;
    }
    const params = {
      ...Object?.fromEntries?.(
        new URLSearchParams(this.props.location?.search),
      ),
      query: `sold_at_range:${sold_at_start},${sold_at_end}`,
    };
    this.props.getSalesReport?.(params);
  }

  render() {
    const {
      authHasOffice = false,
      getSalesReport = () => {},
      sales: { data: sales = [], links = [] } = {},
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Sale</h3>
              <div className="card-tools d-print-none">
                <Pagination getList={getSalesReport} links={links} />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '350px' }}
                >
                  <div className="input-group-prepend">
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={this.onDownload.bind(this)}
                      type="button"
                    >
                      <i className="fas fa-download"></i>
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={this.onSearch.bind(this)}
                      type="button"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                  <input
                    className="form-control"
                    name="sold_at_start"
                    onChange={this.onChange.bind(this)}
                    type="date"
                  />
                  <input
                    className="form-control"
                    name="sold_at_end"
                    onChange={this.onChange.bind(this)}
                    type="date"
                  />
                </div>
              </div>
            </div>
            <div className="card-body p-0 table-responsive">
              {sales?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {sales?.length > 0 && (
                <table className="small table table-sm table-striped text-nowrap">
                  <thead>
                    <tr>
                      {!authHasOffice && <th>Office</th>}
                      <th>Sold At</th>
                      <th>Model</th>
                      <th className="text-right">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sales?.map?.((row, i) => (
                      <tr key={i}>
                        {!authHasOffice && <td>{row.office?.name}</td>}
                        <td>{row.sold_at}</td>
                        <td>{row.vehicle?.model}</td>
                        <td className="text-right">{row.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  sales: state?.report?.sales,
});

const mapDispatchToProps = dispatch => ({
  getSalesReport: params => dispatch(ReportAction.getSalesReport(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sale);
